export interface IGroundLoyaltyProgram {
  vendorName: string;
  loyaltyProgramName: string;
  loyaltyProgramCode: string;
  label?: JSX.Element;
}

export const groundLoyaltyProgramList: IGroundLoyaltyProgram[] = [
  {
    loyaltyProgramName: "Hertz Gold+",
    loyaltyProgramCode: "ZE",
    vendorName: "Hertz",
  },
  {
    loyaltyProgramName: "Dollar Express Rewards",
    loyaltyProgramCode: "ZR",
    vendorName: "Dollar",
  },
  {
    loyaltyProgramName: "Thrifty Blue Chip Rewards",
    loyaltyProgramCode: "ZT",
    vendorName: "Thrifty",
  },
];

const loyaltyProgramCodeMap = groundLoyaltyProgramList.reduce(
  (acc, loyaltyProgram) => {
    acc[loyaltyProgram.loyaltyProgramCode] = loyaltyProgram;
    return acc;
  },
  {} as Record<string, IGroundLoyaltyProgram>
);

export type GroundLoyaltyProgramCode = keyof typeof loyaltyProgramCodeMap;

export const getGroundLoyaltyProgram = (loyaltyProgramCode: string) => {
  if (!loyaltyProgramCodeMap[loyaltyProgramCode]) {
    return null;
  }

  return loyaltyProgramCodeMap[loyaltyProgramCode];
};
